// Все тексты интерфейса — вне кода компонентов (NFR-L10N-01). MVP — только русский.
export const t = {
  app: { name: "Умная бровка" },
  common: {
    next: "Дальше",
    back: "Назад",
    close: "Закрыть",
    cancel: "Отмена",
    save: "Сохранить",
    listen: "Прослушать",
    retry: "Повторить",
    loading: "Загружаем…",
    offline: "Нет сети — всё загруженное работает",
    devContent: "Тестовый контент: не утверждён редакцией",
    minutes: (n: number) => `${n} мин`,
    updateReady: "Доступна новая версия приложения",
    updateNow: "Обновить",
  },
  tabs: { today: "Сегодня", catalog: "Каталог", guide: "Гид", progress: "Прогресс", settings: "Настройки" },
  onboarding: {
    s1Title: "Помогаем понять футбол — вам и ребёнку",
    s1Text: "Короткие анимации на тактической доске, простые задания и подсказки для родителей.",
    s2Title: "Тренер главнее приложения",
    s2Text: "Если тренер просит делать иначе — слушайте тренера. Мы помогаем понять игру, а не заменяем занятия.",
    understood: "Понятно",
    profileTitle: "Кто будет играть?",
    nickname: "Как зовут ребёнка? (можно прозвище)",
    birthYear: "Год рождения",
    stage: "Ступень",
    format: "Формат игры сейчас",
    stageAuto: (name: string) => `Подобрано по возрасту: «${name}». Можно изменить.`,
    consent: "Я родитель или законный представитель и согласен(на) на обработку данных ребёнка: прозвища и года рождения",
    privacy: "Мы храним только прозвище и год рождения — без фото, полной даты и контактов ребёнка.",
    ready: "Готово",
    modeTitle: "Смотрите сами или вместе с ребёнком?",
    together: "Вместе с ребёнком",
    self: "Сам",
    install: "Установите приложение на «Домой»: так прогресс не пропадёт и всё работает без сети.",
  },
  today: {
    hello: (name: string) => `Привет! ${name}`,
    recommended: "Рекомендуем сегодня",
    playKid: "Играть с ребёнком",
    watchSelf: "Посмотреть самому",
    guide: "Футбол для родителей за 10 минут",
    week: "Прогресс",
    askAfter: "Спросите после тренировки",
    noContent: "Загружаем сценарии…",
    contentError: "Не удалось загрузить сценарии. Проверьте интернет и попробуйте ещё раз.",
    saveProgress: "Сохраните прогресс — войдите по email",
    saveProgressText: "Тогда прогресс не пропадёт при очистке браузера и будет виден на втором устройстве.",
  },
  catalog: {
    title: "Каталог",
    stage: "Ступень",
    all: "Все",
    courses: "Курсы",
    scenarios: (n: number) => `${n} сценариев`,
    exercises: "Упражнения во дворе",
    played: "Пройден",
    new: "Новый",
  },
  player: {
    levels: { kid: "Ребёнку", parent: "Родителю", coach: "Тренеру" },
    step: (i: number, n: number) => `Шаг ${i} из ${n}`,
    correct: "Правильно",
    wrong: "Неправильно",
    wrongLabel: "Так не надо",
    play: "Смотреть",
    pause: "Пауза",
    prev: "Предыдущий шаг",
    next: "Следующий шаг",
    replay: "Повторить шаг",
    restart: "Сначала",
    speed: "Скорость",
    tryIt: "Попробуй сам →",
    why: "Почему так?",
    mistakes: "Частые ошибки",
    sayToKid: "Как сказать ребёнку",
    home: "Поиграйте во дворе",
    askAfter: "Спросите после тренировки",
    howMade: "Как создан этот сценарий",
    howMadeText:
      "Подготовлено с помощью ИИ на основе методических источников, прошло автоматические проверки и независимую ИИ-рецензию, утверждено редакцией.",
    howMadeDev: "Тестовая версия: сценарий ещё не утверждён редакцией.",
    sources: "Источники",
    lastCheck: "Последняя проверка",
    report: "Сообщить об ошибке",
    outcome: "Что получилось",
    notFound: "Сценарий не найден или скрыт",
  },
  quiz: {
    missing: "Задание недоступно",
    attempt: (n: number) => `Попытка ${n}`,
    tryAgain: "Давай посмотрим ещё раз!",
    showAnswer: "Смотри, куда лучше бежать!",
    whereHelp: "Перетащите героя или нажмите на место на поле.",
    options: "Варианты ответа",
    resultTitle: "Результат",
    great: "Отлично!",
    ok: "Хорошо!",
    bad: "Попробуем в следующий раз",
    again: "Ещё раз (зеркально)",
    toPlayer: "К сценарию",
  },
  complaint: {
    title: "Сообщить об ошибке",
    kinds: {
      wrong_explanation: "Неверное объяснение",
      age_mismatch: "Не соответствует возрасту",
      animation: "Ошибка анимации",
      typo: "Опечатка",
      other: "Другое",
    } as Record<string, string>,
    comment: "Комментарий (необязательно, без личных данных)",
    send: "Отправить",
    thanks: "Спасибо! Мы разберём сообщение в течение 3 дней.",
    queued: "Сообщение сохранено и уйдёт, когда появится сеть.",
  },
  guide: { title: "Гид для родителя", basics: "Футбол для родителей за 10 минут", support: "Как поддерживать ребёнка", problems: "Что делать, если…", related: "По теме", sources: "Источники" },
  exercise: {
    goal: "Цель",
    equipment: "Что нужно",
    area: "Площадка",
    participants: "Участники",
    duration: "Длительность",
    steps: "Как играть",
    harder: "Как усложнить",
    easier: "Как упростить",
    safety: "Безопасность",
    done: "Сделали!",
    doneThanks: "Отлично! Засчитали в прогресс.",
    conditions: { flat: "Квартира", yard: "Двор", pitch: "Площадка" } as Record<string, string>,
  },
  progress: {
    title: "Прогресс",
    statuses: { not_started: "Не начат", introducing: "Знакомимся", progressing: "Получается", mastered: "Освоен" } as Record<string, string>,
    empty: "Пока нет ответов. Посмотрите сценарий и попробуйте задание.",
    answers: (n: number) => `ответов с первой попытки: ${n}`,
    synced: (when: string) => `Синхронизировано: ${when}`,
    notSynced: "Ещё не синхронизировано",
  },
  settings: {
    title: "Настройки",
    child: "Профиль ребёнка",
    addChild: "Добавить ребёнка",
    sessionLimit: "Лимит детской сессии",
    sound: "Звук и озвучка",
    theme: "Тема",
    themes: { system: "Как в системе", light: "Светлая", dark: "Тёмная" } as Record<string, string>,
    account: "Аккаунт",
    anonymous: "Прогресс сохраняется на сервере без регистрации. Войдите по email, чтобы вернуть его после очистки браузера или на другом устройстве.",
    loggedIn: (email: string) => `Вы вошли как ${email}`,
    email: "Email",
    sendCode: "Получить код",
    code: "Код из письма",
    verify: "Войти",
    codeSent: "Код отправлен. Проверьте почту (и папку «Спам»).",
    merged: "Готово! Прогресс с этого устройства объединён с вашим аккаунтом.",
    bound: "Готово! Email привязан, прогресс сохранён.",
    deleteTitle: "Удалить аккаунт и все данные",
    deleteText: "Удалятся профили детей и весь прогресс на сервере и на этом устройстве. Это нельзя отменить.",
    deleteConfirm: "Удалить навсегда",
    deleteCode: "Для аккаунта с email нужен код из письма.",
    deleted: "Данные удалены.",
    version: (v: string, r: string) => `Версия ${v} · контент ${r}`,
    syncNow: "Синхронизировать сейчас",
  },
  kid: {
    start: "Поехали!",
    lock: "Для взрослых",
    rotate: "Поверни телефон боком!",
    end: "Отлично поиграли! Теперь пора с мячом во двор!",
    callParent: "Позови взрослого!",
    stars: (n: number) => `Звёзд: ${n}`,
    sessionPath: ["Разминка", "Смотрим", "Задания", "Награда"],
  },
  gate: {
    title: "Только для взрослых",
    hold: "Нажмите и удерживайте 3 секунды",
    question: (a: number, b: number) => `Сколько будет ${a} × ${b}?`,
    wrong: "Неверно, попробуйте ещё раз",
  },
  errors: { generic: "Что-то пошло не так", rateLimited: "Слишком часто. Попробуйте через минуту.", offline: "Нет связи с сервером" },
} as const;

/** Склонение «N лет». */
export function years(n: number): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return `${n} год`;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return `${n} года`;
  return `${n} лет`;
}
